import { Injectable } from '@angular/core';

@Injectable()
export class TokenService {

  public getToken(): string {
    return JSON.parse(localStorage.getItem('token'));
  }

  public setToken(token: string) {
    localStorage.setItem('token', JSON.stringify(token));
  }

  /**
   * I so not think should be storing this in local storage.
   *
   * @param refreshToken
   */
  public setRefreshToken(refreshToken: string) {
    localStorage.setItem('refreshToken', JSON.stringify(refreshToken));
  }

  public getRefreshToken(): string {
    return JSON.parse(localStorage.getItem('refreshToken'));
  }


  public clearTokens() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  }

  constructor() {
  }
}
